module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    class: {
      "concentration-line": _vm.unit.type === "concentration"
    }
  }), _vm._v(" "), (_vm.unit.type === "concentration") ? _c('i', {
    staticClass: "concentration-icon fas fa-circle"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-name",
    style: (_vm.nameStyle),
    on: {
      "click": _vm.goToPlans
    }
  }, [_c('div', {
    staticClass: "unit-name-wrap"
  }, [_c('div', {
    staticClass: "unit-type"
  }, [_vm._v(_vm._s(_vm.unit.type))]), _vm._v("\n          " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (_vm.active) ? [_c('div', {
    staticClass: "unit-level"
  }, [(_vm.level) ? _c('span', [_vm._v(_vm._s(_vm.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-availability"
  }, [(_vm.onlineAvailability) ? _c('span', [_vm._v(_vm._s(_vm.onlineAvailability))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-plans"
  }, [(_vm.planPeriod) ? _c('span', [_vm._v(_vm._s(_vm.planCount) + " " + _vm._s(_vm.planString))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-credits"
  }, [(_vm.planPeriod) ? _c('span', [_vm._v(_vm._s(_vm.planPeriod.major_credits) + " Credits")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-buttons"
  }, [(_vm.unit.has_info || _vm.unit.cip_code) ? _c('router-link', {
    attrs: {
      "to": {
        name: "unit-info",
        params: _vm.unitParams
      }
    }
  }, [_c('button', {
    staticClass: "hollow"
  }, [_vm._v("Info")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "unit-buttons"
  }, [(_vm.planPeriod) ? _c('router-link', {
    attrs: {
      "to": {
        name: "unit-plans",
        params: _vm.unitParams
      }
    }
  }, [_c('button', {
    staticClass: "hollow"
  }, [_vm._v(_vm._s(_vm.planString))])]) : _vm._e()], 1)] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f984282","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit_current.vue
// module id = 1133
// module chunks = 1